import {alt} from 'epic-react-common';
import generateWithAsyncActions from 'epic-alt-utils';

/**
 * PosaRedeemActions
 */

export default generateWithAsyncActions(
  alt,
  ['getCmsContent', 'validateCode', 'redeemCode', 'track'],
  ['resetFlow', 'resetErrorCode', 'setPlatform', 'setShowConfirm', 'setPsnCountry']
);
